<div>
  <app-mat-spinner-overlay *ngIf="showSpinner"> </app-mat-spinner-overlay>
  <div class="row m-0 mb-3">
    <div class="col-md-12">
      <div class="custom-tab-switcher d-flex">
        <!-- My Task Tab -->
        <div
          class="tab-item me-2"
          [ngClass]="{ active: tab === 'initiatePayment' }"
          (click)="changeTab('initiatePayment')"
        >
          Initiate Payment
        </div>
        <!-- Status  Tab -->
        <div
          class="tab-item me-2"
          [ngClass]="{ active: tab === 'status' }"
          (click)="changeTab('status')"
        >
          Status
        </div>
        <!-- Payee tab -->
        <div
          class="tab-item me-2"
          [ngClass]="{ active: tab === 'payeTab' }"
          (click)="changeTab('payeTab')"
        >
          Payee
        </div>
      </div>
    </div>
  </div>
  <!-- Initiate Payment -->
  <div class="mb-3" *ngIf="tab == 'initiatePayment'">
    <form class="formborder" #df="ngForm" novalidate class="formborder">
      <div class="row m-0 col-md-12 p-0">
        <div class="col-md-2">
          <span class="required-lable"> Debit to</span>
          <select
            name="DebitTo"
            id="DebitTo"
            class="form-control input-text-css"
            [(ngModel)]="DebitTo"
            #refDebitTo="ngModel"
            required
            (change)="resetInputs()"
            [ngClass]="{
              'is-invalid': df.submitted && refDebitTo.invalid,
              'alert-warning':
                refDebitTo.invalid &&
                (refDebitTo.dirty || refDebitTo.touched || refDebitTo.untouched)
            }"
          >
            <option [ngValue]="null" disabled selected>Select Debit To</option>
            <option *ngFor="let item of DebitToList" [ngValue]="item">
              {{ item.Name }}
            </option>
          </select>
        </div>
        <div class="col-md-2">
          <span class="required-lable"> Branch</span>
          <select
            name="BranchId"
            id="BranchId"
            class="form-control input-text-css"
            [(ngModel)]="BranchId"
            #refBranchId="ngModel"
            required
            [ngClass]="{
              'is-invalid': df.submitted && refBranchId.invalid,
              'alert-warning':
                refBranchId.invalid &&
                (refBranchId.dirty ||
                  refBranchId.touched ||
                  refBranchId.untouched)
            }"
          >
            <option [ngValue]="null" selected>Select Branch</option>
            <option
              *ngFor="let branch of empBranchDropdown"
              [value]="branch.BranchId"
              title="branch.Branch_Name"
            >
              {{ branch.Branch_Name }}
            </option>
          </select>
        </div>
        <div class="col-md-2">
          <span class="required-lable"> PAYEE </span>
          <select
            name="PAYEE"
            id="PAYEE"
            class="form-control input-text-css"
            [(ngModel)]="selectedPayee"
            #refPAYEE="ngModel"
            required
            (change)="onPayeeSelect()"
            [ngClass]="{
              'is-invalid': df.submitted && refPAYEE.invalid,
              'alert-warning':
                refPAYEE.invalid &&
                (refPAYEE.dirty || refPAYEE.touched || refPAYEE.untouched)
            }"
          >
            <option [ngValue]="null" disabled selected>Select PAYEE</option>
            <option *ngFor="let data of PayeeData" [ngValue]="data">
              {{ data.Payee_Name }}
            </option>
          </select>
        </div>
        <div class="col-md-2">
          <span class="required-lable">Amount</span>
          <div class="datepicker_feild">
            <input
              type="text"
              min="0"
              name="Amount"
              id="Amount"
              class="form-control input-text-css"
              placeholder="Amount"
              [(ngModel)]="Amount"
              required
              appTwoDigitDecimaNumber
              (change)="onAmountChange()"
              (keyup.enter)="onAmountChange()"
              #refAmount="ngModel"
              [ngClass]="{
                'is-invalid': df.submitted && refAmount.invalid,
                'alert-warning':
                  refAmount.invalid &&
                  (refAmount.dirty || refAmount.touched || refAmount.untouched)
              }"
            />
          </div>
        </div>
        <div class="col-md-2">
          <span class="required-lable"> Payment Mode </span>
          <select
            name="PaymentMode"
            id="PaymentMode"
            [(ngModel)]="PaymentMode"
            #refPaymentMode="ngModel"
            class="form-control input-text-css"
            required
            [ngClass]="{
              'is-invalid': df.submitted && refPaymentMode.invalid,
              'alert-warning':
                refPaymentMode.invalid &&
                (refPaymentMode.dirty ||
                  refPaymentMode.touched ||
                  refPaymentMode.untouched)
            }"
          >
            <option value="">Select Payment Mode</option>
            <option value="Internal Fund Transfer">
              Internal Fund Transfer
            </option>
            <option value="RTGS">RTGS</option>
            <option value="IMPS">IMPS</option>
            <option value="NEFT">NEFT</option>
          </select>
        </div>
        <div class="col-md-2">
          <span class="required-lable"> Credit to</span>
          <select
            name="CreditTo"
            id="CreditTo"
            class="form-control input-text-css"
            [(ngModel)]="CreditTo"
            #refCreditTo="ngModel"
            required
            [ngClass]="{
              'is-invalid': df.submitted && refCreditTo.invalid,
              'alert-warning':
                refCreditTo.invalid &&
                (refCreditTo.dirty ||
                  refCreditTo.touched ||
                  refCreditTo.untouched)
            }"
          >
            <option [ngValue]="null" selected>Select Credit To</option>
            <option *ngFor="let item of CreditToList" [ngValue]="item">
              {{ item.Account_Name }}
            </option>
          </select>
        </div>
      </div>
      <div class="row m-0 col-md-12 p-0">
        <div class="col-md-2" *ngIf="selectedPayee">
          <span class="required-lable">AC No</span>
          <div class="datepicker_feild">
            <input
              name="AccountNo"
              id="AccountNo"
              class="form-control input-text-css"
              [ngModel]="selectedPayee?.Account_No"
              required
              disabled
              #refAcNo="ngModel"
            />
          </div>
        </div>
        <div class="col-md-2" *ngIf="selectedPayee">
          <span class="required-lable">Bank Name</span>
          <div class="datepicker_feild">
            <input
              name="BankName"
              id="BankName"
              class="form-control input-text-css"
              [ngModel]="selectedPayee?.Bank_Name"
              required
              disabled
              #refbankName="ngModel"
            />
          </div>
        </div>
        <div class="col-md-2" *ngIf="selectedPayee">
          <span class="required-lable">IFSC</span>
          <div class="datepicker_feild">
            <input
              name="IFSCCode"
              id="IFSCCode"
              class="form-control input-text-css"
              [ngModel]="selectedPayee?.IFSC_Code"
              required
              disabled
              #refIFSC="ngModel"
            />
          </div>
        </div>
      </div>
      <div class="row col-md-12">
        <div class="col-md-8">
          <span class="required-lable">Narration</span>
          <input
            type="text"
            name="VoucherNarration"
            id="VoucherNarration"
            [(ngModel)]="VoucherNarration"
            placeholder="Remark"
            class="form-control input-text-css w-full"
            #refVoucherNarration="ngModel"
            required
            [ngClass]="{
              'is-invalid': df.submitted && refVoucherNarration.invalid,
              'alert-warning':
                refVoucherNarration.invalid &&
                (refVoucherNarration.dirty ||
                  refVoucherNarration.touched ||
                  refVoucherNarration.untouched)
            }"
          />
        </div>
      </div>

      <div *ngIf="Tax_Slab_Data?.length" class="mt-3">
        <table class="table table-sm table-bordered">
          <thead>
            <tr>
              <th>Account Name</th>
              <th>Tax Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Amount</td>
              <td>{{ Amount }}</td>
            </tr>
            <tr *ngFor="let item of Tax_Slab_Data">
              <td>{{ item.Account_Name }}</td>
              <td>{{ item.TaxAmount }}</td>
            </tr>

            <tr>
              <td><b>Total Debit Amount</b></td>
              <td>
                <b>{{ creditDebitAmount }}</b>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="col-md-12 d-flex justify-content-end mr-3 mt-2">
        <button
          type="button"
          class="btn font-size-12 button-btn"
          [disabled]="!df.form.valid"
          [class.spinner]="loading"
          (click)="onInitaite()"
        >
          Initiate
        </button>
      </div>
    </form>
    <div class="row m-0 col-md-12 p-0 formborder">
      <div class="col-md-4 p-1 mt-2">
        <!-- <mat-form-field>
      <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Search ....">
    </mat-form-field> -->
        <form action="" class="search-text">
          <div class="bg-light rounded rounded-pill shadow-sm">
            <div class="input-group">
              <input
                type="text"
                id="FilterInputSearch"
                (keyup)="applyFilter($event.target.value)"
                name="FilterInputSearch"
                placeholder="What're you searching for?"
                class="form-control border-0 bg-light"
              />
              <div class="input-group-append">
                <button
                  id="button-addon1"
                  type="submit"
                  class="btn btn-link text-primary"
                >
                  <i class="fa fa-search"></i>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    <!-- Initiate Table -->
    <div class="table-responsive mt-2">
      <mat-table [dataSource]="dataInitiateSource">
        <ng-container matColumnDef="Id" style="max-width: 50px">
          <mat-header-cell
            matSort
            class="grid-header"
            style="max-width: 50px"
            *matHeaderCellDef
            >#</mat-header-cell
          >

          <mat-cell
            *matCellDef="let row; let i = index"
            class="grid-cell"
            style="max-width: 50px"
          >
            {{ paginatorRef.pageIndex * paginatorRef.pageSize + (i + 1) }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="DebitTo">
          <mat-header-cell class="grid-header" *matHeaderCellDef>
            Debit To
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="grid-cell">
            {{ row.DebitTo }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="Payee_Name">
          <mat-header-cell class="grid-header" *matHeaderCellDef>
            PAYEE
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="grid-cell">
            {{ row.Payee_Name }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="Account_No">
          <mat-header-cell class="grid-header" *matHeaderCellDef>
            AC No
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="grid-cell">
            {{ row.Account_No }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="Bank_Name">
          <mat-header-cell class="grid-header" *matHeaderCellDef>
            Bank Name
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="grid-cell">
            {{ row.Bank_Name }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="IFSC_Code">
          <mat-header-cell class="grid-header" *matHeaderCellDef>
            IFSC
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="grid-cell">
            {{ row.IFSC_Code }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="paymentMethodName">
          <mat-header-cell class="grid-header" *matHeaderCellDef>
            Payment Mode
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="grid-cell">
            {{ row.paymentMethodName }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="amount">
          <mat-header-cell class="grid-header" *matHeaderCellDef>
            Amount
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="grid-cell">
            {{ row.amount }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="Action">
          <mat-header-cell class="grid-header j-c-center" *matHeaderCellDef
            >Action</mat-header-cell
          >
          <mat-cell *matCellDef="let row" class="grid-cell j-c-center">
            <button
              type="button"
              name="E-Request{{ i }}"
              id="E-Request{{ i }}"
              (click)="EStatusCheckModel(row)"
              class="font-size-12 button-btn"
              [class.spinner]="loading"
            >
              Status Check
            </button>
          </mat-cell>
        </ng-container>
        <mat-header-row
          *matHeaderRowDef="displayedInitiateColumns"
        ></mat-header-row>
        <mat-row
          *matRowDef="let row; columns: displayedInitiateColumns"
        ></mat-row>
      </mat-table>
      <div class="row m-0 align-items-center">
        <div class="col-md-4">
          <button
            class="mt-3 btn font-size-12 button-btn"
            (click)="exportExcelInitiate()"
          >
            <i
              class="fa fa-file-export mr-1"
              style="font-size: medium; cursor: pointer"
            ></i>
            Export
          </button>
        </div>
        <div class="col-md-8">
          <mat-paginator
            #paginatorRef
            [pageSizeOptions]="[20, 50]"
            showFirstLastButtons
          >
          </mat-paginator>
        </div>
      </div>
    </div>
    <!-- Export -->
    <div class="row m-0 mt-3" [hidden]="!dataInitiateSource">
      <table
        id="exportInitiate"
        class="table table-bordered bg-white"
        style="font-family: 'Times New Roman', Times, serif; display: none"
      >
        <tr>
          <th style="background: #4dc3a3 !important; border: 1px solid white">
            #
          </th>
          <th style="background: #4dc3a3 !important; border: 1px solid white">
            Debit To
          </th>
          <th style="background: #4dc3a3 !important; border: 1px solid white">
            PAYEE
          </th>
          <th style="background: #4dc3a3 !important; border: 1px solid white">
            AC No
          </th>
          <th style="background: #4dc3a3 !important; border: 1px solid white">
            Bank Name
          </th>
          <th style="background: #4dc3a3 !important; border: 1px solid white">
            IFSC
          </th>
          <th style="background: #4dc3a3 !important; border: 1px solid white">
            Payment Mode
          </th>
          <th style="background: #4dc3a3 !important; border: 1px solid white">
            Amount
          </th>
        </tr>
        <tr *ngFor="let x of PayeeData; let i = index">
          <td>{{ i + 1 }}</td>
          <td>{{ x.DebitTo }}</td>
          <td>{{ x.Payee_Name }}</td>
          <td>{{ x.Account_No }}</td>
          <td>{{ x.Bank_Name }}</td>
          <td>{{ x.IFSC_Code }}</td>
          <td>{{ x.amount }}</td>
          <td>{{ x.paymentMethodName }}</td>
        </tr>
      </table>
    </div>
    <div
      class="modal fade in"
      id="GSTModalWindow"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      data-backdrop="false"
      style="background-color: rgba(0, 0, 0, 0.5); overflow: auto"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div
          cdkDrag
          cdkDragRootElement=".cdk-overlay-pane"
          class="modal-content"
        >
          <div cdkDragHandle class="modal-header" style="padding: 10px">
            <h6 class="modal-title" id="myModalLabel" name="myModalLabel">
              Party Detail
            </h6>
            <button
              type="button"
              class="close"
              (click)="OnCloseGSTModal()"
              aria-label="Close"
            >
              <span aria-hidden="true"
                ><i class="far text-black fa-times-circle"></i
              ></span>
            </button>
          </div>
          <form #cf="ngForm" novalidate>
            <div class="modal-body">
              <div class="row m-0 mt-1">
                <div class="col-md-4">
                  <span class="form-check-inline">
                    <label class="form-check-label" for="Existing Party">
                      <input
                        type="radio"
                        class="form-check-input"
                        id="PartyType"
                        name="PartyType"
                        [(ngModel)]="GSTModel.PartyType"
                        required
                        value="Existing_Party"
                        (change)="onPartyTypeChange()"
                      />
                      Existing Party
                    </label>
                  </span>
                </div>
                <div class="col-md-8">
                  <span class="form-check-inline">
                    <label class="form-check-label" for="New Party">
                      <input
                        type="radio"
                        class="form-check-input"
                        id="PartyType"
                        name="PartyType"
                        [(ngModel)]="GSTModel.PartyType"
                        required
                        value="New_Party"
                        (change)="onPartyTypeChange()"
                      />
                      New Party
                    </label>
                  </span>
                </div>
              </div>

              <div class="row m-0 mt-2">
                <div class="col-md-3">
                  <span class="required-lable">Tax Slab</span>
                </div>
                <div class="col-md-9">
                  <select
                    name="Slab_Tax"
                    id="Slab_Tax"
                    #refSlab_Tax="ngModel"
                    class="form-control input-text-css"
                    required
                    [ngClass]="{
                      'is-invalid': cf.submitted && refSlab_Tax.invalid,
                      'alert-warning':
                        refSlab_Tax.invalid &&
                        (refSlab_Tax.dirty ||
                          refSlab_Tax.touched ||
                          refSlab_Tax.untouched)
                    }"
                    [(ngModel)]="GSTModel.Slab_Tax"
                  >
                    <option value="">Select Slab</option>
                    <option
                      [value]="slab.TaxSlab_Name"
                      *ngFor="let slab of slabList"
                    >
                      {{ slab.TaxSlab_Name }}
                    </option>
                  </select>
                </div>
              </div>
              <div
                class="row m-0 mt-2"
                *ngIf="GSTModel.PartyType == 'Existing_Party'"
              >
                <div class="col-md-3">
                  <span class="required-lable">Account</span>
                </div>
                <div class="col-md-9">
                  <select
                    name="AccountHeadId"
                    id="AccountHeadId"
                    #refAccountHeadId="ngModel"
                    required
                    [ngClass]="{
                      'is-invalid': cf.submitted && refAccountHeadId.invalid,
                      'alert-warning':
                        refAccountHeadId.invalid &&
                        (refAccountHeadId.dirty ||
                          refAccountHeadId.touched ||
                          refAccountHeadId.untouched)
                    }"
                    [(ngModel)]="GSTModel.AccountHeadId"
                    class="form-control input-text-css"
                    (change)="onAccountHeadChange()"
                  >
                    <option value="">Select Account</option>
                    <option
                      *ngFor="let item of AccountHeadForGST"
                      [value]="item.AccountId"
                    >
                      {{ item.Account_Name }}
                    </option>
                  </select>
                </div>
              </div>

              <div
                class="row m-0 mt-2"
                *ngIf="GSTModel.PartyType == 'New_Party'"
              >
                <div class="col-md-3">
                  <span class="required-lable">Name</span>
                </div>
                <div class="col-md-9">
                  <input
                    type="text"
                    #refCustomer="ngModel"
                    class="form-control input-text-css"
                    placeholder="Name"
                    required
                    [ngClass]="{
                      'is-invalid': cf.submitted && refCustomer.invalid,
                      'alert-warning':
                        refCustomer.invalid &&
                        (refCustomer.dirty ||
                          refCustomer.touched ||
                          refCustomer.untouched)
                    }"
                    [(ngModel)]="GSTModel.Customer"
                    name="Customer"
                    id="Customer"
                    [disabled]="GSTModel.PartyType == 'Existing_Party'"
                  />
                </div>
              </div>
              <div class="row m-0 mt-2">
                <div class="col-md-3"><span>GST No.</span></div>
                <div class="col-md-9">
                  <input
                    type="text"
                    #refAcc_GSTNo="ngModel"
                    class="form-control input-text-css"
                    placeholder="GST No."
                    [(ngModel)]="GSTModel.Acc_GSTNo"
                    name="Acc_GSTNo"
                    id="Acc_GSTNo"
                  />
                  <!--[disabled]="GSTModel.PartyType == 'Existing_Party'"-->
                </div>
              </div>
              <div class="row m-0 mt-2">
                <div class="col-md-3"><span>State</span></div>
                <div class="col-md-9">
                  <select
                    name="State"
                    id="State"
                    #refState="ngModel"
                    class="form-control input-text-css"
                    [(ngModel)]="GSTModel.StateId"
                    [disabled]="GSTModel.PartyType == 'Existing_Party'"
                  >
                    <option value="">Select State</option>
                    <option
                      *ngFor="let state of stateDropdown"
                      [value]="state.StateId"
                    >
                      {{ state.State_Name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="row m-0 mt-2">
                <div class="col-md-3"><span>HSN Code</span></div>
                <div class="col-md-9">
                  <input
                    name="HSNCode"
                    id="HSNCode"
                    [(ngModel)]="GSTModel.HSNCode"
                    placeholder="HSN Code"
                    class="form-control input-text-css"
                  />
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn font-size-12 button-btn"
                (click)="OnCloseGSTModal()"
              >
                Cancel
              </button>
              <button
                type="button"
                class="ml-4 mt-3 btn font-size-12 button-btn"
                (click)="saveGSTDetails()"
                [class.spinner]="loading"
                [disabled]="!cf.form.valid"
              >
                Save
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <!-- Status -->
  <div class="mb-3" *ngIf="tab == 'status'">
    <form class="formborder" #df="ngForm" novalidate class="formborder">
      <div class="row m-0 col-md-12 p-0">
        <div class="col-md-2">
          <span class="required-lable"> Type</span>
          <select
            name="Type"
            id="Type"
            class="form-control input-text-css"
            [(ngModel)]="Type"
            #refType="ngModel"
            required
            (change)="onTypeChange($event)"
            [ngClass]="{
              'is-invalid': df.submitted && refType.invalid,
              'alert-warning':
                refType.invalid &&
                (refType.dirty || refType.touched || refType.untouched)
            }"
          >
            <option value="AuthorizedOn">Authorized On</option>
            <option value="InitiateOn">Initiate On</option>
          </select>
        </div>

        <div class="col-md-2">
          <span>From Date</span>
          <div class="datepicker_feild">
            <input
              [matDatepicker]="picker"
              dateConvert
              required
              placeholder="DD/MM/YYYY"
              name="FromDate"
              id="FromDate"
              #refFromdate="ngModel"
              class="form-control input-text-css"
              [(ngModel)]="FromDate"
              [max]="ToDate"
            />
            <!-- [ngClass]="{
                'is-invalid': at.submitted && refToDate.invalid,
                'alert-warning':
                  refToDate.invalid &&
                  (refToDate.dirty || refToDate.touched || refToDate.untouched)
              }" -->
            <mat-datepicker-toggle
              matSuffix
              [for]="picker"
            ></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </div>
        </div>
        <div class="col-md-2">
          <span>To Date</span>
          <div class="datepicker_feild">
            <input
              [matDatepicker]="picker2"
              dateConvert
              [min]="FromDate"
              placeholder="DD/MM/YYYY"
              name="ToDate"
              id="ToDate"
              #refTodate="ngModel"
              class="form-control input-text-css"
              [(ngModel)]="ToDate"
              [min]="FromDate"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="picker2"
            ></mat-datepicker-toggle>
            <mat-datepicker #picker2></mat-datepicker>
          </div>
        </div>
        <div class="col-md-2">
          <span>Status</span>
          <select
            name="st"
            [(ngModel)]="Status"
            class="form-control form-select"
            required
            [disabled]="Type === 'AuthorizedOn'"
          >
            <option value="">Select Status</option>
            <option value="PAID">PAID</option>
            <option value="FAILED">FAILED</option>
          </select>
        </div>
        <div class="col-md-2">
          <span class="required-lable"> PAYEE </span>
          <select
            name="PAYEE"
            id="PAYEE"
            class="form-control input-text-css"
            [(ngModel)]="selectedStatusPayee"
            #refPAYEE="ngModel"
            [ngClass]="{
              'is-invalid': df.submitted && refPAYEE.invalid,
              'alert-warning':
                refPAYEE.invalid &&
                (refPAYEE.dirty || refPAYEE.touched || refPAYEE.untouched)
            }"
          >
            <option [ngValue]="null" selected>Select PAYEE</option>
            <option *ngFor="let data of PayeeData" [ngValue]="data">
              {{ data.Payee_Name }}
            </option>
          </select>
        </div>
        <div class="col-md-2">
          <span class="required-lable"> Debit to</span>
          <select
            name="DebitTo"
            id="DebitTo"
            class="form-control input-text-css"
            [(ngModel)]="StatusDebitTo"
            #refDebitTo="ngModel"
            [ngClass]="{
              'is-invalid': df.submitted && refDebitTo.invalid,
              'alert-warning':
                refDebitTo.invalid &&
                (refDebitTo.dirty || refDebitTo.touched || refDebitTo.untouched)
            }"
          >
            <option [ngValue]="null" selected>Select Debit To</option>
            <option *ngFor="let item of DebitToList" [ngValue]="item">
              {{ item.Name }}
            </option>
          </select>
        </div>
        <div class="col-md-1">
          <button
            class="mt-3 btn font-size-12 button-btn"
            (click)="LMS_Get_OtherPayment_Statement()"
          >
            Search
          </button>
        </div>
      </div>
    </form>
    <div class="table-responsive mt-2">
      <mat-table [dataSource]="dataStatusSource">
        <ng-container matColumnDef="Id" style="max-width: 50px">
          <mat-header-cell
            class="grid-header"
            style="max-width: 50px"
            *matHeaderCellDef
            >#</mat-header-cell
          >

          <mat-cell
            *matCellDef="let row; let i = index"
            class="grid-cell"
            style="max-width: 50px"
          >
            {{ paginatorRef.pageIndex * paginatorRef.pageSize + (i + 1) }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="DebitTo">
          <mat-header-cell class="grid-header" *matHeaderCellDef>
            Debit To
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="grid-cell">
            {{ row.DebitTo }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="Payee_Name">
          <mat-header-cell class="grid-header" *matHeaderCellDef>
            PAYEE
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="grid-cell">
            {{ row.Payee_Name }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="Account_No">
          <mat-header-cell class="grid-header" *matHeaderCellDef>
            AC No
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="grid-cell">
            {{ row.Account_No }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="IFSC_Code">
          <mat-header-cell class="grid-header" *matHeaderCellDef>
            IFSC
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="grid-cell">
            {{ row.IFSC_Code }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="batchNo">
          <mat-header-cell class="grid-header" *matHeaderCellDef>
            Batch No
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="grid-cell">
            {{ row.batchNo }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="uniqueRequestId">
          <mat-header-cell class="grid-header" *matHeaderCellDef>
            Unique Request Id
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="grid-cell">
            {{ row.uniqueRequestId }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="paymentMethodName">
          <mat-header-cell class="grid-header" *matHeaderCellDef>
            Payment Mode
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="grid-cell">
            {{ row.paymentMethodName }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="amount">
          <mat-header-cell class="grid-header" *matHeaderCellDef>
            Amount
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="grid-cell">
            {{ row.amount }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="Bank_Name">
          <mat-header-cell class="grid-header" *matHeaderCellDef>
            Bank Name
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="grid-cell">
            {{ row.Bank_Name }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="Status">
          <mat-header-cell class="grid-header" *matHeaderCellDef>
            Status
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="grid-cell">
            {{ row.Status }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="CreatedBy">
          <mat-header-cell class="grid-header" *matHeaderCellDef>
            Created by
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="grid-cell">
            {{ row.CreatedBy }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="CreatedOn">
          <mat-header-cell class="grid-header" *matHeaderCellDef>
            Created On
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="grid-cell">
            {{ row.CreatedOn }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="ReferenceNo">
          <mat-header-cell class="grid-header" *matHeaderCellDef>
            Reference No
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="grid-cell">
            {{ row.ReferenceNo }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="AuthorizedOn">
          <mat-header-cell class="grid-header" *matHeaderCellDef>
            Authorized On
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="grid-cell">
            {{ row.AuthorizedOn }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="FailedMsg">
          <mat-header-cell class="grid-header" *matHeaderCellDef>
            Failed Msg
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="grid-cell">
            {{ row.FailedMsg }}
          </mat-cell>
        </ng-container>
        <mat-header-row
          *matHeaderRowDef="displayedSourceColumns"
        ></mat-header-row>
        <mat-row
          *matRowDef="let row; columns: displayedSourceColumns"
        ></mat-row>
      </mat-table>
      <div class="row m-0 align-items-center">
        <div class="col-md-4">
          <button
            class="mt-3 btn font-size-12 button-btn"
            (click)="exportExcelStatus()"
          >
            <i
              class="fa fa-file-export mr-1"
              style="font-size: medium; cursor: pointer"
            ></i>
            Export
          </button>
        </div>
        <div class="col-md-8">
          <mat-paginator
            #paginatorRef
            [pageSizeOptions]="[20, 50]"
            showFirstLastButtons
          >
          </mat-paginator>
        </div>
      </div>
    </div>
    <!-- Export Table -->
    <div class="row m-0 mt-3" [hidden]="!dataStatusSource">
      <table
        id="exportStatus"
        class="table table-bordered bg-white"
        style="font-family: 'Times New Roman', Times, serif; display: none"
      >
        <thead>
          <tr>
            <th style="background: #4dc3a3 !important; border: 1px solid white">
              #
            </th>
            <th style="background: #4dc3a3 !important; border: 1px solid white">
              Debit To
            </th>
            <th style="background: #4dc3a3 !important; border: 1px solid white">
              PAYEE
            </th>
            <th style="background: #4dc3a3 !important; border: 1px solid white">
              AC No
            </th>
            <th style="background: #4dc3a3 !important; border: 1px solid white">
              Bank Name
            </th>
            <th style="background: #4dc3a3 !important; border: 1px solid white">
              IFSC
            </th>
            <th style="background: #4dc3a3 !important; border: 1px solid white">
              Batch No
            </th>
            <th style="background: #4dc3a3 !important; border: 1px solid white">
              Unique Request Id
            </th>
            <th style="background: #4dc3a3 !important; border: 1px solid white">
              Payment Mode
            </th>
            <th style="background: #4dc3a3 !important; border: 1px solid white">
              Amount
            </th>
            <th style="background: #4dc3a3 !important; border: 1px solid white">
              Status
            </th>
            <th style="background: #4dc3a3 !important; border: 1px solid white">
              Created By
            </th>
            <th style="background: #4dc3a3 !important; border: 1px solid white">
              Created On
            </th>
            <th style="background: #4dc3a3 !important; border: 1px solid white">
              Reference No
            </th>
            <th style="background: #4dc3a3 !important; border: 1px solid white">
              Authorized On
            </th>
            <th style="background: #4dc3a3 !important; border: 1px solid white">
              Failed Msg
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let x of StatusData; let i = index">
            <td>{{ i + 1 }}</td>
            <td>{{ x.DebitTo }}</td>
            <td>{{ x.Payee_Name }}</td>
            <td>{{ x.Account_No }}</td>
            <td>{{ x.Bank_Name }}</td>
            <td>{{ x.IFSC_Code }}</td>
            <td>{{ x.batchNo }}</td>
            <td>{{ x.uniqueRequestId }}</td>
            <td>{{ x.paymentMethodName }}</td>
            <td>{{ x.amount }}</td>
            <td>{{ x.Status }}</td>
            <td>{{ x.CreatedBy }}</td>
            <td>{{ x.CreatedOn }}</td>
            <td>{{ x.ReferenceNo }}</td>
            <td>{{ x.AuthorizedOn }}</td>
            <td>{{ x.FailedMsg }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!--Payee  -->
  <div class="mb-3" *ngIf="tab == 'payeTab'">
    <form class="formborder" #df="ngForm" novalidate>
      <div class="row m-0 col-md-12 p-0">
        <div class="col-md-2">
          <button
            type="button"
            (click)="openModal()"
            class="mt-3 btn font-size-12 button-btn"
          >
            Add Payee
          </button>
        </div>
      </div>
    </form>

    <!-- Add Payee Model -->
    <div
      class="modal fade in"
      id="payeeModel"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      data-backdrop="false"
      style="background-color: rgba(0, 0, 0, 0.5); overflow: auto"
    >
      <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header" style="padding: 10px">
            <h6 class="modal-title" id="myModalLabel" name="myModalLabel">
              {{ updateBtn ? "Edit Payee" : "Add Payee" }}
            </h6>
            <button
              type="button"
              (click)="closeModal()"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true"
                ><i class="far text-black fa-times-circle"></i
              ></span>
            </button>
          </div>
          <div class="modal-body" style="border: none">
            <div class="table-responsive">
              <form #f="ngForm" novalidate class="formborder">
                <div class="col-md-12">
                  <div class="row col-md-12 d-flex">
                    <div class="col-md-4">
                      <span class="required-lable"> Payee Name </span>
                      <input
                        type="text"
                        name="PayeeName"
                        id="PayeeName"
                        [(ngModel)]="PayeeName"
                        placeholder="Payee Name"
                        class="form-control input-text-css w-full"
                        #refPayeeName="ngModel"
                        required
                        [ngClass]="{
                          'is-invalid': f.submitted && refPayeeName.invalid,
                          'alert-warning':
                            refPayeeName.invalid &&
                            (refPayeeName.dirty ||
                              refPayeeName.touched ||
                              refPayeeName.untouched)
                        }"
                      />
                    </div>
                    <div class="col-md-4">
                      <span class="required-lable">Bank Name</span>
                      <input
                        type="text"
                        name="BankName"
                        id="BankName"
                        [(ngModel)]="BankName"
                        placeholder="Bank Name"
                        class="form-control input-text-css w-full"
                        #refBankName="ngModel"
                        required
                        [ngClass]="{
                          'is-invalid': f.submitted && refBankName.invalid,
                          'alert-warning':
                            refBankName.invalid &&
                            (refBankName.dirty ||
                              refBankName.touched ||
                              refBankName.untouched)
                        }"
                      />
                    </div>
                    <div class="col-md-4">
                      <span class="required-lable">Bank Branch</span>
                      <input
                        type="text"
                        name="BankBranch"
                        id="BankBranch"
                        [(ngModel)]="BankBranch"
                        placeholder="Bank Branch"
                        class="form-control input-text-css w-full"
                        #refBankBranch="ngModel"
                        required
                        [ngClass]="{
                          'is-invalid': f.submitted && refBankBranch.invalid,
                          'alert-warning':
                            refBankBranch.invalid &&
                            (refBankBranch.dirty ||
                              refBankBranch.touched ||
                              refBankBranch.untouched)
                        }"
                      />
                    </div>
                  </div>
                  <div class="row col-md-12 d-flex">
                    <div class="col-md-4">
                      <span class="required-lable">Account No</span>
                      <input
                        type="number"
                        name="AccountNo"
                        id="AccountNo"
                        [(ngModel)]="AccountNo"
                        placeholder="Bank A/C No"
                        class="form-control input-text-css w-full"
                        #refAccountNo="ngModel"
                        required
                        [ngClass]="{
                          'is-invalid': f.submitted && refAccountNo.invalid,
                          'alert-warning':
                            refAccountNo.invalid &&
                            (refAccountNo.dirty ||
                              refAccountNo.touched ||
                              refAccountNo.untouched)
                        }"
                      />
                    </div>
                    <div class="col-md-4">
                      <span class="required-lable">IFSC Code</span>
                      <input
                        type="text"
                        name="IFSCCode"
                        id="IFSCCode"
                        [(ngModel)]="IFSCCode"
                        (input)="IFSCCode = IFSCCode.toUpperCase()"
                        placeholder="IFSC Code"
                        class="form-control input-text-css w-full"
                        #refIFSCCode="ngModel"
                        required
                        minlength="11"
                        maxlength="11"
                        [ngClass]="{
                          'is-invalid': f.submitted && refIFSCCode.invalid,
                          'alert-warning':
                            refIFSCCode.invalid &&
                            (refIFSCCode.dirty ||
                              refIFSCCode.touched ||
                              refIFSCCode.untouched)
                        }"
                      />
                      <div
                        *ngIf="
                          refIFSCCode.errors?.minlength ||
                          refIFSCCode.errors?.maxlength
                        "
                      >
                        IFSC Code must be exactly 11 characters.
                      </div>

                      <!-- Validation Message -->

                      <!-- <div
                                       have to add in input to see the validation        pattern="[A-Za-z]{4}[0-9]{7}"

                        *ngIf="(refIFSCCode.invalid && (refIFSCCode.dirty || refIFSCCode.touched || f.submitted))"
                        class="text-danger mt-1"
                        style="font-size: 12px;"
                      >
                        <div *ngIf="refIFSCCode.errors?.required">IFSC Code is required.</div>
                        <div *ngIf="refIFSCCode.errors?.minlength || refIFSCCode.errors?.maxlength">
                          IFSC Code must be exactly 11 characters.
                        </div>
                        <div *ngIf="refIFSCCode.errors?.pattern">
                          Invalid IFSC Code format.
                        </div>
                      </div> -->
                    </div>

                    <div class="col-md-4">
                      <span class="required-lable"> A/C Type </span>
                      <select
                        name="BankAcType"
                        id="BankAcType"
                        [(ngModel)]="Account_Type"
                        #refBankAcType="ngModel"
                        class="form-control input-text-css"
                        required
                        [ngClass]="{
                          'is-invalid': f.submitted && refBankAcType.invalid,
                          'alert-warning':
                            refBankAcType.invalid &&
                            (refBankAcType.dirty ||
                              refBankAcType.touched ||
                              refBankAcType.untouched)
                        }"
                      >
                        <option value="">Select A/C Type</option>
                        <option value="Saving">Saving A/C</option>
                        <option value="Current">Current A/C</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-12 d-flex justify-content-end mr-3 mt-2">
                    <button
                      type="button"
                      class="btn font-size-12 button-btn"
                      [disabled]="!f.form.valid"
                      [class.spinner]="loading"
                      (click)="onSavePayeeDetail()"
                    >
                      {{ updateBtn ? "Update" : "Save" }}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Payee table -->
    <div class="table-responsive mt-2">
      <mat-table [dataSource]="dataPayeeSource" matSort>
        <ng-container matColumnDef="Payee_Id">
          <mat-header-cell
            class="grid-header"
            style="max-width: 50px"
            *matHeaderCellDef
            >#</mat-header-cell
          >

          <mat-cell
            *matCellDef="let row; let i = index"
            class="grid-cell"
            style="max-width: 60px; max-height: 5px"
          >
            {{ paginatorRef.pageIndex * paginatorRef.pageSize + (i + 1) }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="Payee_Name">
          <mat-header-cell class="grid-header" *matHeaderCellDef>
            Payee Name
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="grid-cell">
            {{ row.Payee_Name }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="Bank_Name">
          <mat-header-cell class="grid-header" *matHeaderCellDef>
            Bank Name
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="grid-cell">
            {{ row.Bank_Name }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="Bank_Branch">
          <mat-header-cell class="grid-header" *matHeaderCellDef>
            Bank Branch
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="grid-cell">
            {{ row.Bank_Branch }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="Account_No">
          <mat-header-cell class="grid-header" *matHeaderCellDef>
            Account No
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="grid-cell">
            {{ row.Account_No }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="IFSC_Code">
          <mat-header-cell class="grid-header" *matHeaderCellDef>
            IFSC Code
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="grid-cell">
            {{ row.IFSC_Code }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="Account_Type">
          <mat-header-cell class="grid-header" *matHeaderCellDef>
            Account Type
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="grid-cell">
            {{ row.Account_Type }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="Action">
          <mat-header-cell class="grid-header j-c-center" *matHeaderCellDef
            >Action</mat-header-cell
          >
          <mat-cell *matCellDef="let row" class="grid-cell j-c-center">
            <i
              class="fas fa-lg fa-edit margin-right-4xs cursor-style"
              aria-label="true"
              (click)="editPayeeInfo(row)"
            ></i>
            <i
              class="fa fa-trash style-delete"
              (click)="removePayee(row)"
              aria-label="true"
            ></i>
          </mat-cell>
        </ng-container>
        <mat-header-row
          *matHeaderRowDef="displayedPayeeColumns"
        ></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedPayeeColumns"></mat-row>
      </mat-table>
      <div class="row m-0 align-items-center">
        <div class="col-md-4">
          <button
            class="mt-3 btn font-size-12 button-btn"
            (click)="exportPayee()"
          >
            <i
              class="fa fa-file-export mr-1"
              style="font-size: medium; cursor: pointer"
            ></i>
            Export
          </button>
        </div>
        <div class="col-md-8">
          <mat-paginator
            #paginatorRef
            [pageSizeOptions]="[20, 50]"
            showFirstLastButtons
          >
          </mat-paginator>
        </div>
      </div>
    </div>

    <!-- Export -->

    <div class="row m-0 mt-3" [hidden]="!dataPayeeSource">
      <table
        id="exportPayee"
        class="table table-bordered bg-white"
        style="font-family: 'Times New Roman', Times, serif; display: none"
      >
        <tr>
          <th style="background: #4dc3a3 !important; border: 1px solid white">
            #
          </th>
          <th style="background: #4dc3a3 !important; border: 1px solid white">
            Payee Name
          </th>
          <th style="background: #4dc3a3 !important; border: 1px solid white">
            Bank Name
          </th>
          <th style="background: #4dc3a3 !important; border: 1px solid white">
            Bank Branch
          </th>
          <th style="background: #4dc3a3 !important; border: 1px solid white">
            Account No
          </th>
          <th style="background: #4dc3a3 !important; border: 1px solid white">
            IFSC_Code
          </th>
          <th style="background: #4dc3a3 !important; border: 1px solid white">
            Account_Type
          </th>
        </tr>
        <tr *ngFor="let x of JsonData; let i = index">
          <td>{{ i + 1 }}</td>
          <td>{{ x.Payee_Name }}</td>
          <td>{{ x.Bank_Name }}</td>
          <td>{{ x.Bank_Branch }}</td>
          <td>{{ x.Account_No }}</td>
          <td>{{ x.IFSC_Code }}</td>
          <td>{{ x.Account_Type }}</td>
        </tr>
      </table>
    </div>
  </div>
  <div class="row m-0 col-md-12 mt-2">
    <div class="col-md-12 text-right">
      <button
        type="button"
        (click)="updateToken()"
        class="mt-3 font-size-12 button-btn"
      >
        Update AU Payment Token
      </button>
    </div>
  </div>
</div>
